import React from 'react';

interface RouteLoaderWrapperProps {
  isLoading: boolean; 
  children: React.ReactNode;
}

export function RouteLoaderWrapper({ isLoading, children }: RouteLoaderWrapperProps) {
  if (isLoading) {
    return (
      <div className="bg-[#f9fafb] h-screen w-full flex items-center justify-center">
        <span className="text-gray-500 text-sm">Loading wallet connection...</span>
      </div>
    );
  }

  return <>{children}</>;
}
